import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@app/core/services';

export const authGuard: CanActivateFn = (route, state) => {
	if (inject(AuthService).isAuth) {
		return true;
	}
	inject(AuthService).logout();
	return false;
};
